// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_xlsx_xlsx_mjs":"4aaee2aababd20f2","node_modules_html2canvas_dist_html2canvas_js":"9fb1a541ff081afd","node_modules_dompurify_dist_purify_js":"59de579e0411ddfb","node_modules_canvg_lib_index_es_js":"fcdbf42a83906dad"}[chunkId] + ".js";
};